// extracted by mini-css-extract-plugin
module.exports = {"button":"AnchorButton_button__2Ag0S btn","link":"AnchorButton_link__2e5KS AnchorButton_button__2Ag0S btn"};